export const CONNECTION = 'connection';